import { withStyles } from '@mui/styles';
import { compose } from 'recompose';
import WidthController from './width-controller';
import { styles } from './width-controller.styles';

export default compose(withStyles(styles))(WidthController);
